// "use client"

// import { Component } from "react"
// import API, { URL_PATH } from "../../services/API"
// import redux from "../../common/Redux"
// import "./styles.css"
// import Colors from "../../common/Colors"
// import routes from "../../routes/URL"
// import { base_url } from "../../services/API"
// import {
//   Box,
//   Container,
//   Typography,
//   TextField,
//   Button,
//   Radio,
//   FormControlLabel,
//   InputAdornment,
//   Card,
//   CardContent,
// } from "@mui/material"
// import { Email, Phone, Person, Refresh, ArrowForward } from "@mui/icons-material"
// import IsolatedStatusModal from "../../components/StatusModal"
// import Toast from "../../components/Toast"
// import axios from "axios"

// const errors = {
//   uname: "invalid username",
//   pass: "invalid mobile",
// }

// class LoginScreen extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       error: null,
//       isLoaded: false,
//       active: "login",
//       otp: "",
//       email: "",
//       mobile: "",
//       name: "",
//       user_id: null,
//       user_type: "outlet",
//       sendingOTP: false,
//       modalOpen: false,
//       modalType: "success",
//       modalTitle: "",
//       modalMessage: "",
//       userData: null,
//       subscriptionPlans: [], // Add this to store plans from API
//       toast: {
//         open: false,
//         message: "",
//         severity: "success",
//       },
//     }
//   }

//   showToast = (message, severity = "success") => {
//     this.setState({
//       toast: {
//         open: true,
//         message,
//         severity,
//       },
//     })
//   }

//   handleCloseToast = (event, reason) => {
//     if (reason === "clickaway") {
//       return
//     }
//     this.setState({
//       toast: {
//         ...this.state.toast,
//         open: false,
//       },
//     })
//   }

//   componentDidMount() {
//     const token = localStorage.getItem("token")
//     if (token && this.props.isAuth) {
//       this.props.history.push(routes.admin.dashboard)
//     }

//     // Load Cashfree SDK
//     const script = document.createElement("script")
//     script.src = "https://sdk.cashfree.com/js/ui/2.0.0/cashfree.sandbox.js"
//     script.async = true
//     document.body.appendChild(script)

//     // Load subscription plans
//     this.loadSubscriptionPlans()
//   }

//   // Add method to load subscription plans
//   loadSubscriptionPlans = async () => {
//     try {
//       const response = await API(this, "get", URL_PATH.subscriptionPlans)
//       const { status, data } = response

//       if (status === "success") {
//         this.setState({ subscriptionPlans: data })
//       }
//     } catch (error) {
//       console.error("Failed to load subscription plans:", error)
//     }
//   }

//   showModal = (type, title, message) => {
//     this.setState({
//       modalOpen: true,
//       modalType: type,
//       modalTitle: title,
//       modalMessage: message,
//     })
//   }

//   closeModal = () => {
//     this.setState({ modalOpen: false })
//   }

//   sendOTP = async (event) => {
//     event.preventDefault()

//     const fd = {
//       user_type: "outlet",
//     }

//     const emailPhone = event.target.email.value

//     if (emailPhone.includes("@")) {
//       fd.check_for = "email"
//       fd.email = emailPhone
//     } else {
//       fd.check_for = "mobile"
//       fd.mobile = emailPhone
//     }

//     const { status, message, data } = await API(this, "post", URL_PATH.login, fd)

//     if (status == "error") {
//       return this.showModal("error", "Error", message)
//     } else if (status == "redirect") {
//       window.location.href = data
//       return
//     } else if (status == "success") {
//       const { otp_length, name, email, mobile, token, message, signup = false, emailDisabled, mobileDisabled } = data

//       this.setState({
//         name,
//         otp_length,
//         token,
//         otpMessage: message,
//         signup,
//         active: "verify",
//         email,
//         mobile,
//         emailDisabled,
//         mobileDisabled,
//       })
//       return
//     }

//     return this.showToast("Something went wrong", "error")
//   }

// handleSubmit = async (event) => {
//   event.preventDefault();
//   const formData = new FormData(event.target);
//   formData.append("user_type", this.state.user_type);

//   try {
//     console.log("Sending OTP verification request...");
//     const result = await API(this, "post", URL_PATH.verify_otp, formData);
//     console.log("Full API Response:", result);

//     if (result.status === "error" || result.success === false || result.length === 0) {
//       const errorMsg = result.message || "Mobile No is already registered";
//       console.log("OTP verification failed:", errorMsg);
//       return this.showToast(errorMsg, "error");
//     }

//     console.log("OTP verification successful:", result);

//     if (result.status === "success" || result.success === true) {
//       console.log("Processing successful OTP verification...");
      
//       // Extract user data from response
//       const { data } = result;
//       console.log("User data from verification:", data);
//       const userId = data?.user?.id || data?.user_id;
//       const userData = data?.user || {};
//       const hasSubscription = data?.active_subscription;
//       const hasOutlet = data?.has_outlet;
      
//       // Store token in localStorage for authenticated requests
//       if (data?.token) {
//         localStorage.setItem("outlatetoken", data.token);
//       }
      
//       console.log("User ID from verification:", userId);
      
//       if (hasSubscription && !hasOutlet) {
//         // User has subscription but no outlet - go directly to create outlet
//         this.setState({
//           active: "create_outlet",
//           user_id: userId,
//           userData: userData,
//         });
//         // this.showToast("Please complete your outlet registration", "info");
//       } else if (!hasSubscription) {
//         // User needs to select a plan
//         this.setState({
//           otp_length: data?.otp_length,
//           token: data?.token,
//           otpMessage: data?.message,
//           active: "payment",
//           user_id: userId,
//           userData: userData,
//         });
//         this.showToast(data?.message || "OTP verified successfully!", "success");
//       } else {
//         // User has both subscription and outlet - redirect to dashboard
//         this.props.history.push(routes.admin.dashboard);
//       }
//       return;
//     }
//   } catch (error) {
//     console.error("API Call Failed:", error);
//     this.showToast("Failed to verify OTP. Please try again.", "error");
//   }
// };

//   CreateOutletBox() {
//     return (
//       <form onSubmit={(e) => this.handleCreateOutlet(e)} id="outlet-form">
//         <Typography variant="h5" sx={{ color: "white", mb: 3, textAlign: "center" }}>
//           Create New Outlet
//         </Typography>

//         <TextField
//           fullWidth
//           name="outlet_name"
//           label="Outlet Name"
//           variant="outlined"
//           margin="normal"
//           required
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Person sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 2,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//             },
//           }}
//         />

//         <TextField
//           fullWidth
//           name="gst_number"
//           label="GST Number"
//           variant="outlined"
//           margin="normal"
//           required
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Person sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 2,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//             },
//           }}
//         />

//         <TextField
//           fullWidth
//           name="fssai_number"
//           label="FSSAI Number"
//           variant="outlined"
//           margin="normal"
//           required
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Person sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 2,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//             },
//           }}
//         />

//         <TextField
//           fullWidth
//           name="phone"
//           label="Phone"
//           variant="outlined"
//           margin="normal"
//           required
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Phone sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 2,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//             },
//           }}
//         />

//         <TextField
//           fullWidth
//           name="address"
//           label="Address"
//           variant="outlined"
//           margin="normal"
//           multiline
//           rows={2}
//           required
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Person sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 2,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//             },
//           }}
//         />

//         <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//           <TextField
//             fullWidth
//             name="city"
//             label="City"
//             variant="outlined"
//             margin="normal"
//             required
//             InputLabelProps={{
//               style: { color: "white" },
//             }}
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 "& fieldset": {
//                   borderColor: "rgba(255, 255, 255, 0.3)",
//                 },
//                 "&:hover fieldset": {
//                   borderColor: "white",
//                 },
//                 "&.Mui-focused fieldset": {
//                   borderColor: Colors.primary,
//                 },
//                 color: "white",
//               },
//             }}
//           />

//           <TextField
//             fullWidth
//             name="state"
//             label="State"
//             variant="outlined"
//             margin="normal"
//             required
//             InputLabelProps={{
//               style: { color: "white" },
//             }}
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 "& fieldset": {
//                   borderColor: "rgba(255, 255, 255, 0.3)",
//                 },
//                 "&:hover fieldset": {
//                   borderColor: "white",
//                 },
//                 "&.Mui-focused fieldset": {
//                   borderColor: Colors.primary,
//                 },
//                 color: "white",
//               },
//             }}
//           />
//         </Box>

//         <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
//           <TextField
//             fullWidth
//             name="pin_code"
//             label="PIN Code"
//             variant="outlined"
//             margin="normal"
//             required
//             InputLabelProps={{
//               style: { color: "white" },
//             }}
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 "& fieldset": {
//                   borderColor: "rgba(255, 255, 255, 0.3)",
//                 },
//                 "&:hover fieldset": {
//                   borderColor: "white",
//                 },
//                 "&.Mui-focused fieldset": {
//                   borderColor: Colors.primary,
//                 },
//                 color: "white",
//               },
//             }}
//           />

//           <TextField
//             fullWidth
//             name="country"
//             label="Country"
//             variant="outlined"
//             margin="normal"
//             defaultValue="India"
//             required
//             InputLabelProps={{
//               style: { color: "white" },
//             }}
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 "& fieldset": {
//                   borderColor: "rgba(255, 255, 255, 0.3)",
//                 },
//                 "&:hover fieldset": {
//                   borderColor: "white",
//                 },
//                 "&.Mui-focused fieldset": {
//                   borderColor: Colors.primary,
//                 },
//                 color: "white",
//               },
//             }}
//           />
//         </Box>

//         <Button
//           type="submit"
//           fullWidth
//           variant="contained"
//           size="large"
//           endIcon={<ArrowForward />}
//           sx={{
//             mt: 1,
//             mb: 2,
//             backgroundColor: Colors.primary,
//             color: "black",
//             fontWeight: "bold",
//             "&:hover": {
//               backgroundColor: Colors.primary,
//               opacity: 0.9,
//             },
//           }}
//         >
//           Create Outlet
//         </Button>
//       </form>
//     )
//   }

// handleCreateOutlet = async (event) => {
//   event.preventDefault();

//   try {
//     const formData = new FormData(event.target);
    
//     // Get user ID from state (set during OTP verification)
//     const userId = this.state.user_id || this.props.auth?.user?.id;
    
//     if (!userId) {
//       return this.showToast("User authentication required", "error");
//     }
  
//     // Create complete outlet data with all required fields
//     const outletData = {
//       parent_hotel_id: this.props.selectedHotelId?.id,
//       outlet_name: formData.get("outlet_name"),
//       gst_number: formData.get("gst_number"),
//       fssai_number: formData.get("fssai_number"),
//       phone: formData.get("phone"),
//       address: formData.get("address"),
//       city: formData.get("city"),
//       state: formData.get("state"),
//       pin_code: formData.get("pin_code"),
//       country: formData.get("country"),
//       user_id: userId, // Include user ID in the payload
//     };

//     console.log("Creating outlet with data:", outletData);

//     const result = await API(this, "post", `${base_url}/hotel/createOutlet`, outletData);

//     if (result.status === "success") {
//       this.showToast("Outlet created successfully!", "success");
//       this.props.history.push(routes.admin.dashboard.root);
//     } else {
//       this.showToast(result.message || "Failed to create outlet", "error");
//     }
//   } catch (error) {
//     console.error("Error creating outlet:", error);
//     this.showToast("An error occurred. Please try again.", "error");
//   }
// };

//   // Updated PaymentBox method with subscription screen styling and logic
//  // Updated PaymentBox method with fixes
// PaymentBox() {
//   const { subscriptionPlans } = this.state
// const predefinedFeatures = {
//     "mini": [
//       "Cloud-Based POS",
//       "Order Tracking",
//       "Pick-Up Orders",
//       "Order History",
//       "Manage Tips",
//       "Discounts & Coupons",
//       "Variations & Add-Ons",
//        "Time-Slot Wise Menu",
//        "Space-Wise Menu Pricing",
//        "Digital QR-Based Menu",
//        "Thermal Print Support",
//         "Cart Sharing",
//         "Digital Token for Queue Mgt.",
//         "User Feedback Collection",
//         "Google Reviews Integration",
//         "Multi-Language Support",
//         "SMS & Notification Alerts",
//         "Real-Time Order Status",
//         "Table & Space Management",
//         "Table & Hall Bookings",
//         "Change / Merge / Split Table",
//         "Third-Party Integrations ",
//         "Payment Gateway Integrations",
//         "Real-Time Dashboard & Reports",
//         "Customer List (CRM)",
//         "iOS, Android & Web Applications",
//         "Daily Cloud Backup",
//         "Special Menu Banner",
//         "24/7 Customer Support",





//       ],
//     "pro": [
//       "Cloud-Based POS",
//       "Order Tracking",
//       "Pick-Up Orders",
//       "Order History",
//       "Manage Tips",
//       "Discounts & Coupons",
//       "Variations & Add-Ons",
//        "Time-Slot Wise Menu",
//        "Space-Wise Menu Pricing",
//        "Digital QR-Based Menu",
//        "Thermal Print Support",
//         "Cart Sharing",
//         "Digital Token for Queue Mgt.",
//         "User Feedback Collection",
//         "Google Reviews Integration",
//         "Multi-Language Support",
//         "SMS & Notification Alerts",
//         "Real-Time Order Status",
//         "Table & Space Management",
//         "Table & Hall Bookings",
//         "Change / Merge / Split Table",
//         "Third-Party Integrations ",
//         "Payment Gateway Integrations",
//         "Real-Time Dashboard & Reports",
//         "Customer List (CRM)",
//         "iOS, Android & Web Applications",
//         "Daily Cloud Backup",
//         "Special Menu Banner",
//         "24/7 Customer Support",
//         "Call the Waiter Feature",
//         "KOT & KDS with Print",
//         "Employee Management",
//         "Inventory Management",
//         "Staff Login with few Permissions"

//     ]
//   };

//   // Filter to show only Mini and Pro plans
//   const filteredPlans = subscriptionPlans
//     .filter(
//       (plan) =>
//         plan.name.toLowerCase().includes("mini") ||
//         plan.name.toLowerCase().includes("pro") ||
//         plan.tier === 1 ||
//         plan.tier === 2,
//     )
//     .filter((plan) => plan.price > 0) // Only paid plans

//   // If no plans from API, use fallback
//   const plansToShow = filteredPlans.length > 0 ? filteredPlans : [
//     {
//       id: 1,
//       name: "Eatable Pro",
//       description: "Perfect for growing businesses",
//       price: 999,
//       monthly_price: 999,
//       tier: 1,
//       features: predefinedFeatures.pro.map(name => ({ name }))
//     },
//     {
//       id: 2,
//       name: "Eatable Mini",
//       description: "Great for small businesses",
//       price: 499,
//       monthly_price: 499,
//       tier: 2,
//       features: predefinedFeatures.mini.map(name => ({ name }))
//     }
//   ];
//   const enhancedPlans = plansToShow.map(plan => {
//     // Determine plan type (mini or pro)
//     const isMini = plan.name.toLowerCase().includes("mini") || plan.tier === 2;
//     const planType = isMini ? "mini" : "pro";
    
//     // Keep all plan data from backend but use predefined feature names
//     return {
//       ...plan,
//       features: predefinedFeatures[planType].map(name => ({ name }))
//     };
//   });

//   return (
//     <div
//       style={{
//         backgroundColor: "#02111B",
//         minHeight: "100vh",
//         fontFamily: "'Poppins', sans-serif",
//         color: "#333",
//         padding: "20px 0",
//       }}
//     >
//       <div
//         style={{
//           maxWidth: "1200px",
//           margin: "0 auto",
//           padding: "0 20px",
          
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             textAlign: "center",
//             marginBottom: "40px",
//           }}
//         >
//           <Typography
//             variant="h4"
//             sx={{
//               fontSize: "32px",
//               fontWeight: "700",
//               color: Colors.primary,
//               margin: "0 0 15px 0",
//               textTransform: "uppercase",
//               letterSpacing: "1px",
//             }}
//           >
//             Choose Your Plan
//           </Typography>
//           <div
//             style={{
//               width: "60px",
//               height: "3px",
//               background: `linear-gradient(90deg, ${Colors.primary}, #ff9a44)`,
//               margin: "0 auto 15px",
//               borderRadius: "2px",
//             }}
//           ></div>
//           <Typography
//             variant="body1"
//             sx={{
//               fontSize: "16px",
//               color: "white",
//               maxWidth: "500px",
//               margin: "0 auto",
//               lineHeight: "1.6",
//             }}
//           >
//             Select the perfect plan for your outlet needs
//           </Typography>
//         </div>

//         {/* Plans Grid */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: plansToShow.length === 1 ? "1fr" : "repeat(auto-fit, minmax(350px, 1fr))",
            
//             marginBottom: "40px",
//             justifyContent: "center",
//           }}
//         >
//           {enhancedPlans.map((item, index) => {
//             const isPopular = item.tier === 1

//             return (
//               <div
//                 key={index}
//                 style={{
//                   position: "relative",
//                   transition: "all 0.3s ease",
//                   borderRadius: "12px",
//                   backgroundColor: "#041A29",
//                   display: "flex",
//                   flexDirection: "column",
//                   maxWidth: "450px",
                 
//                   ...(isPopular
//                     ? {
//                         transform: "translateY(-10px)",
//                         boxShadow: "0 15px 30px rgba(0,0,0,0.15)",
//                         // border: `2px solid ${Colors.primary}`,
//                       }
//                     : {
//                         boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
//                       }),
//                 }}
//               >
              

                

//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     height: "100%",
//                     padding: "30px",
//                   }}
//                 >
//                   <div
//                     style={{
//                       textAlign: "center",
//                       borderBottom: "1px solid #eee",
//                       paddingBottom: "25px",
//                       marginBottom: "25px",
//                     }}
//                   >
//                     <h3
//                       style={{
//                         fontSize: "24px",
//                         fontWeight: "700",
//                         margin: "0 0 10px 0",
//                         color: "white",
//                         ...(isPopular ? { color: Colors.primary } : {}),
//                       }}
//                     >
//                       {item.name}
//                     </h3>
//                     <p
//                       style={{
//                         fontSize: "14px",
//                         color: "white",
//                         margin: "0 0 20px 0",
//                         lineHeight: "1.5",
//                       }}
//                     >
//                       {item.description}
//                     </p>

//                     <div style={{ margin: "25px 0" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "10px",
//                         }}
//                       >
//                         <div style={{ textAlign: "center" }}>
//                           <div
//                             style={{
//                               display: "flex",
//                               alignItems: "flex-start",
//                               justifyContent: "center",
//                             }}
//                           >
//                             <span
//                               style={{
//                                 fontSize: "24px",
//                                 fontWeight: "bold",
//                                 color: "white",
//                                 marginRight: "5px",
//                                 lineHeight: "1",
//                                 ...(isPopular ? { color: Colors.primary } : {}),
//                               }}
//                             >
//                               ₹
//                             </span>
//                             <span
//                               style={{
//                                 fontSize: "48px",
//                                 fontWeight: "800",
//                                 lineHeight: "1",
//                                 color: "white",
//                                 ...(isPopular ? { color: Colors.primary } : {}),
//                               }}
//                             >
//                               {(item.monthly_price || item.price).toLocaleString("en-IN")}
//                             </span>
//                             {item.price > 0 && (
//                               <p
//                                 style={{
//                                   fontSize: "20px",
//                                   color: "#aaa",
//                                   marginTop: "15px",
//                                   marginLeft: "10px",
//                                   textDecoration: "line-through",
//                                 }}
//                               >
//                                 ₹{((item.monthly_price || item.price) * 2).toLocaleString("en-IN")}
//                               </p>
//                             )}
//                           </div>
//                         </div>
//                       </div>

//                       <p
//                         style={{
//                           fontSize: "14px",
//                           color: "white",
//                           margin: "5px 0 0 0",
//                         }}
//                       >
//                         Monthly
//                       </p>
//                       <p style={{ color: "white", fontSize: "16px" }}>BILLED YEARLY</p>
//                     </div>
//                   </div>

//                   <div
//                     style={{
//                       flexGrow: "1",
//                       marginBottom: "25px",
//                     }}
//                   >
//                     <ul
//                       style={{
//                         listStyle: "none",
//                         padding: "0",
//                         margin: "0",
//                       }}
//                     >
//                      {item.features.map((feature, featureIndex) => (
//                           <li
//                             key={featureIndex}
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               marginBottom: "15px",
//                               color: "#555",
//                               fontSize: "15px",
//                               lineHeight: "1.4",
//                             }}
//                           >
//                             <span
//                               style={{
//                                 display: "inline-flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 width: "22px",
//                                 height: "22px",
//                                 borderRadius: "50%",
//                                 background: isPopular ? Colors.primary : "#4CAF50",
//                                 marginRight: "12px",
//                                 fontSize: "12px",
//                                 color: isPopular ? "black" : "white",
//                                 flexShrink: "0",
//                               }}
//                             >
//                               ✓
//                             </span>
//                             <span style={{ color: "white" }}>{feature.name}</span>
//                           </li>
//                         ))}
                  
//                     </ul>
//                   </div>

//                   {/* Individual Select Plan Button */}
//                   <div style={{ textAlign: "center", marginTop: "auto" }}>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       endIcon={<ArrowForward />}
//                       onClick={() => this.handleIndividualPlanSelection(item.id)}
//                       sx={{
//                         width: "100%",
//                         padding: "12px 30px",
//                         backgroundColor: item.tier === 1 ? Colors.primary : "#00A651",
//                         color: item.tier === 1 ? "black" : "white",
//                         fontWeight: "bold",
//                         fontSize: "16px",
//                         borderRadius: "30px",
//                         boxShadow:
//                           item.tier === 1
//                             ? "0 4px 15px rgba(250, 172, 64, 0.3)"
//                             : "0 4px 15px rgba(76, 175, 80, 0.3)",
//                         "&:hover": {
//                           backgroundColor: item.tier === 1 ? Colors.primary : "#00A651",
//                           opacity: 0.9,
//                           transform: "translateY(-2px)",
//                           boxShadow:
//                             item.tier === 1
//                               ? "0 6px 20px rgba(250, 172, 64, 0.4)"
//                               : "0 6px 20px rgba(76, 175, 80, 0.4)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       Select Plan
//                       {item.tier === 1 && (
//                         <span style={{ marginLeft: "8px" }}>→</span>
//                       )}
//                     </Button>
//                   </div>
//                 </div>
//               </div>
//             )
//           })}
//         </div>
//       </div>
//     </div>
//   )
// }

// handleIndividualPlanSelection = async (planId) => {
//   if (!planId) {
//     return this.showToast("Invalid plan selection", "error");
//   }

//   try {
//     // For free plan, go directly to create outlet
//     if (planId === "4") {
//       this.setState({ active: "create_outlet" });
//       return;
//     }

//     // Get user ID from state
//     const userId = this.state.user_id;
    
//     if (!userId) {
//       return this.showToast("User authentication required", "error");
//     }

//     // For paid plans, initialize payment
//     const paymentData = {
//       plan_id: planId,
//       type: "subscribe",
//       payment_gateway: "cashfree",
//       outlate_user_id: userId, // Use the stored user ID
//     };

//     console.log("Payment data with user ID:", paymentData);

//     const token = localStorage.getItem("outlatetoken") || localStorage.getItem("token");

//     try {
//       const response = await axios.post(`${base_url}/subscription/subscribe`, paymentData, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       console.log("Payment API response:", response.data);

//       if (response.data.status !== "success") {
//         return this.showToast(response.data.message || "Payment initiation failed", "error");
//       }

//       this.processCashfreePayment(response.data);
//     } catch (error) {
//       console.error("API error:", error);
//       this.showToast("There was an error initiating your payment. Please try again.", "error");
//     }
//   } catch (error) {
//     console.error("Payment error:", error);
//     this.showToast("There was an error initiating your payment", "error");
//   }
// };

//   handlePaymentSelection = async (event) => {
//     event.preventDefault()
//     const formData = new FormData(event.target)
//     const planId = formData.get("plan_id")

//     if (!planId) {
//       return this.showToast("Please select a plan to continue", "error")
//     }

//     try {
//       // For free plan, go directly to create outlet
//       if (planId === "4") {
//         this.setState({ active: "create_outlet" })
//         return
//       }

//       // For paid plans, initialize payment
//       const paymentData = {
//         plan_id: planId,
//         type: "subscribe",
//         payment_gateway: "cashfree",
//         outlate_user_id: this.state.user_id,
//       }

//       const token = localStorage.getItem("outlatetoken") || localStorage.getItem("token")

//       try {
//         const base_url = "https://etableapp.in/api/hotelowner"
//         const response = await axios.post(`${base_url}/subscription/subscribe`, paymentData, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         })

//         console.log("Payment API response:", response.data)

//         if (response.data.status !== "success") {
//           return this.showToast(response.data.message || "Payment initiation failed", "error")
//         }

//         this.processCashfreePayment(response.data)
//       } catch (error) {
//         console.error("API error:", error)
//         this.showToast("There was an error initiating your payment. Please try again.", "error")
//       }
//     } catch (error) {
//       console.error("Payment error:", error)
//       this.showToast("There was an error initiating your payment", "error")
//     }
//   }

//   processCashfreePayment = (response) => {
//     try {
//       const { payment_session_id } = response.data

//       if (!payment_session_id) {
//         return this.showToast("Invalid Cashfree payment session data", "error")
//       }

//       if (window.Cashfree) {
//         const paymentContainer = document.getElementById("payment-container")
//         if (paymentContainer) {
//           paymentContainer.style.display = "flex"
//           paymentContainer.innerHTML = ""

//           const innerContainer = document.createElement("div")
//           innerContainer.style.position = "relative"
//           innerContainer.style.width = "450px"
//           innerContainer.style.maxWidth = "90%"
//           innerContainer.style.backgroundColor = "white"
//           innerContainer.style.borderRadius = "8px"
//           innerContainer.style.padding = "20px"
//           innerContainer.style.boxShadow = "0 5px 15px rgba(0,0,0,0.3)"

//           const closeButton = document.createElement("button")
//           closeButton.innerHTML = "×"
//           closeButton.style.position = "absolute"
//           closeButton.style.top = "10px"
//           closeButton.style.right = "10px"
//           closeButton.style.background = "none"
//           closeButton.style.border = "none"
//           closeButton.style.color = "#333"
//           closeButton.style.fontSize = "24px"
//           closeButton.style.cursor = "pointer"
//           closeButton.onclick = () => {
//             paymentContainer.style.display = "none"
//             paymentContainer.innerHTML = ""
//           }
//           innerContainer.appendChild(closeButton)

//           const formContainer = document.createElement("div")
//           formContainer.id = "cashfree-form"
//           formContainer.style.marginTop = "20px"
//           innerContainer.appendChild(formContainer)

//           paymentContainer.appendChild(innerContainer)
//         }

//         const cashfree = new window.Cashfree(payment_session_id)

//         const dropinConfig = {
//           components: ["order-details", "card", "netbanking", "app", "upi"],
//           onSuccess: (data) => {
//             console.log("Cashfree success:", data)
//             const paymentContainer = document.getElementById("payment-container")
//             if (paymentContainer) {
//               paymentContainer.style.display = "none"
//             }

//             if (data.order && data.order.status === "PAID") {
//               this.paid(data)
//               this.setState({ active: "create_outlet" })
//             } else {
//               this.showToast("Payment is not confirmed yet. Please wait for confirmation.", "warning")
//             }
//           },
//           onFailure: (data) => {
//             console.log("Cashfree failure:", data)
//             const paymentContainer = document.getElementById("payment-container")
//             if (paymentContainer) {
//               paymentContainer.style.display = "none"
//             }
//             this.showToast("Payment failed. Please try again.", "error")
//           },
//           style: {
//             backgroundColor: "#f9f9f9",
//             color: "#11385b",
//             fontFamily: "Poppins, sans-serif",
//             fontSize: "14px",
//             errorColor: "#ff0000",
//             theme: "light",
//           },
//         }

//         cashfree.drop(document.getElementById("cashfree-form"), dropinConfig)
//       } else {
//         console.error("Cashfree SDK not loaded")
//         this.showToast("Failed to initialize payment", "error")
//       }
//     } catch (error) {
//       console.error("Cashfree payment error:", error)
//       this.showToast("Failed to initialize payment", "error")
//     }
//   }

//   paid = async (data) => {
//     try {
//       const fd = {
//         custom: true,
//         orderId: data.order?.orderId,
//         status: data.order?.status,
//         gateway: "cashfree",
//       }

//       const response = await API(this, "post", URL_PATH.paymentDone, fd)
//       const { status, message } = response

//       if (status === "success") {
//         this.showToast("Payment processed successfully", "success")
//         this.setState({ active: "create_outlet" })
//       } else {
//         this.showToast(message || "Payment verification failed", "error")
//       }
//     } catch (error) {
//       console.error("Payment processing error:", error)
//       this.showToast("There was an error processing your payment", "error")
//     }
//   }

//   RenderBox() {
//     console.log("Current active state in RenderBox:", this.state.active)
//     if (this.state.active == "login") return this.LoginBox()
//     if (this.state.active == "signup") return this.SignUpBox()
//     if (this.state.active == "verify") return this.VerifyBox()
//     if (this.state.active == "create_outlet") {
//       console.log("Rendering CreateOutletBox")
//       return this.CreateOutletBox()
//     }
//     // Payment case is now handled in render() method directly
//     return null
//   }

//   renderErrorMessage = (name) => {
//     return <div className="error-message">{errors[name]}</div>
//   }

//   LoginBox() {
//     return (
//       <form onSubmit={(e) => this.sendOTP(e)} id="login-form">
//         <TextField
//           fullWidth
//           name="email"
//           label="Email/Mobile"
//           variant="outlined"
//           margin="normal"
//           value={this.state.email}
//           onChange={(e) => this.setState({ email: e.target.value })}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Person sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 3,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//             },
//           }}
//         />

//         <Button
//           type="submit"
//           fullWidth
//           variant="contained"
//           size="large"
//           endIcon={<ArrowForward />}
//           sx={{
//             mt: 1,
//             mb: 2,
//             backgroundColor: Colors.primary,
//             color: "black",
//             fontWeight: "bold",
//             "&:hover": {
//               backgroundColor: Colors.primary,
//               opacity: 0.9,
//             },
//           }}
//         >
//           Continue
//         </Button>
//       </form>
//     )
//   }

//   SignUpBox() {
//     return (
//       <form onSubmit={(e) => this.handleSubmit(e)} id="login-form">
//         <TextField
//           fullWidth
//           name="name"
//           label="Name"
//           variant="outlined"
//           margin="normal"
//           value={this.state.name}
//           onChange={(e) => this.setState({ name: e.target.value })}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Person sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 2,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//             },
//           }}
//         />

//         <TextField
//           fullWidth
//           name="email"
//           label="Email (username)"
//           variant="outlined"
//           margin="normal"
//           value={this.state.email}
//           onChange={(e) => this.setState({ email: e.target.value })}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Email sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 2,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//             },
//           }}
//         />

//         <TextField
//           fullWidth
//           name="mobile"
//           label="Mobile Number"
//           variant="outlined"
//           margin="normal"
//           value={this.state.mobile}
//           onChange={(e) => this.setState({ mobile: e.target.value })}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Phone sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 3,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//             },
//           }}
//         />

//         <input type="hidden" name="user_type" value="hotel" />

//         <Button
//           type="submit"
//           fullWidth
//           variant="contained"
//           size="large"
//           endIcon={<ArrowForward />}
//           sx={{
//             mt: 1,
//             mb: 2,
//             backgroundColor: Colors.primary,
//             color: "black",
//             fontWeight: "bold",
//             "&:hover": {
//               backgroundColor: Colors.primary,
//               opacity: 0.9,
//             },
//           }}
//         >
//           Submit
//         </Button>
//       </form>
//     )
//   }

//   VerifyBox() {
//     const {
//       otp_length,
//       token,
//       otp,
//       otpMessage,
//       signup = false,
//       emailDisabled = false,
//       mobileDisabled = false,
//       sendingOTP,
//     } = this.state

//     return (
//       <form onSubmit={(e) => this.handleSubmit(e)} id="login-form">
//         <input type="hidden" name="key" value={token} />

//         <Box sx={{ mb: 3, mt: 2 }}>
//           <Typography variant="body1" sx={{ color: "white", mb: 2, mt: 2 }}>
//             {otpMessage}
//           </Typography>

//           <TextField
//             fullWidth
//             name="otp"
//             label="Verification Code"
//             variant="outlined"
//             type="number"
//             inputProps={{
//               maxLength: otp_length,
//               minLength: otp_length,
//             }}
//             value={otp}
//             onChange={(e) => this.setState({ otp: e.target.value })}
//             InputLabelProps={{
//               style: { color: "white" },
//             }}
//             sx={{
//               mb: 2,
//               "& .MuiOutlinedInput-root": {
//                 "& fieldset": {
//                   borderColor: "rgba(255, 255, 255, 0.3)",
//                 },
//                 "&:hover fieldset": {
//                   borderColor: "white",
//                 },
//                 "&.Mui-focused fieldset": {
//                   borderColor: Colors.primary,
//                 },
//                 color: "white",
//               },
//             }}
//           />

//           <Button
//             variant="text"
//             startIcon={<Refresh />}
//             disabled={sendingOTP}
//             onClick={async () => {
//               this.setState({ sendingOTP: true, otp: "" })
//               const result = await API(this, "post", URL_PATH.resendOtp, { key: token })
//               const { status, data, message } = result
//               if (status == "success") {
//                 this.setState({
//                   token: data.token,
//                   sendingOTP: false,
//                 })
//               } else {
//                 this.showToast(message, "error")
//                 this.setState({ sendingOTP: false })
//               }
//             }}
//             sx={{
//               color: Colors.primary,
//               textTransform: "none",
//               "&:hover": {
//                 backgroundColor: "rgba(255, 255, 255, 0.05)",
//               },
//             }}
//           >
//             Resend OTP
//           </Button>
//         </Box>

//         {signup == false && (
//           <>
//             <TextField
//               fullWidth
//               name="name"
//               label="Name"
//               variant="outlined"
//               margin="normal"
//               value={this.state.name}
//               onChange={(e) => this.setState({ name: e.target.value })}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Person sx={{ color: "white" }} />
//                   </InputAdornment>
//                 ),
//               }}
//               InputLabelProps={{
//                 style: { color: "white" },
//               }}
//               sx={{
//                 mb: 2,
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": {
//                     borderColor: "rgba(255, 255, 255, 0.3)",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: "white",
//                   },
//                   "&.Mui-focused fieldset": {
//                     borderColor: Colors.primary,
//                   },
//                   color: "white",
//                 },
//               }}
//             />

//             <TextField
//               fullWidth
//               name="email"
//               label="Email"
//               variant="outlined"
//               margin="normal"
//               value={this.state.email}
//               onChange={(e) => this.setState({ email: e.target.value })}
//               disabled={emailDisabled}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Email sx={{ color: emailDisabled ? "gray" : "white" }} />
//                   </InputAdornment>
//                 ),
//               }}
//               InputLabelProps={{
//                 style: { color: emailDisabled ? "gray" : "white" },
//               }}
//               sx={{
//                 mb: 2,
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": {
//                     borderColor: "rgba(255, 255, 255, 0.3)",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: emailDisabled ? "gray" : "white",
//                   },
//                   "&.Mui-focused fieldset": {
//                     borderColor: emailDisabled ? "gray" : Colors.primary,
//                   },
//                   color: emailDisabled ? "gray" : "white",
//                 },
//               }}
//             />

//             <TextField
//               fullWidth
//               name="mobile"
//               label="Mobile Number"
//               variant="outlined"
//               margin="normal"
//               value={this.state.mobile}
//               onChange={(e) => this.setState({ mobile: e.target.value })}
//               disabled={mobileDisabled}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Phone sx={{ color: mobileDisabled ? "gray" : "white" }} />
//                   </InputAdornment>
//                 ),
//               }}
//               InputLabelProps={{
//                 style: { color: mobileDisabled ? "gray" : "white" },
//               }}
//               sx={{
//                 mb: 3,
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": {
//                     borderColor: "rgba(255, 255, 255, 0.3)",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: mobileDisabled ? "gray" : "white",
//                   },
//                   "&.Mui-focused fieldset": {
//                     borderColor: mobileDisabled ? "gray" : Colors.primary,
//                   },
//                   color: mobileDisabled ? "gray" : "white",
//                 },
//               }}
//             />

//             <input type="hidden" name="user_type" value="hotel" />
//           </>
//         )}

//         <Button
//           type="submit"
//           fullWidth
//           variant="contained"
//           size="large"
//           endIcon={<ArrowForward />}
//           sx={{
//             mt: 1,
//             mb: 2,
//             backgroundColor: Colors.primary,
//             color: "black",
//             fontWeight: "bold",
//             "&:hover": {
//               backgroundColor: Colors.primary,
//               opacity: 0.9,
//             },
//           }}
//         >
//           Continue
//         </Button>
//       </form>
//     )
//   }

//   render() {
//     // If payment state, render full-width payment section
//     if (this.state.active === "payment") {
//       return (
//         <div>
//           <Toast
//             open={this.state.toast.open}
//             message={this.state.toast.message}
//             severity={this.state.toast.severity}
//             handleClose={this.handleCloseToast}
//           />

//           <div
//             id="payment-container"
//             style={{
//               position: "fixed",
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               backgroundColor: "rgba(0,0,0,0.7)",
//               display: "none",
//               alignItems: "center",
//               justifyContent: "center",
//               zIndex: 1000,
//             }}
//           ></div>
//           {this.PaymentBox()}


//           <IsolatedStatusModal
//             isOpen={this.state.modalOpen}
//             onClose={this.closeModal}
//             type={this.state.modalType}
//             title={this.state.modalTitle}
//             message={this.state.modalMessage}
//             buttonText="OK"
//           />
//         </div>
//       )
//     }

//     // For all other states, use the constrained container layout
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           padding: "20px",
//           boxSizing: "border-box",
//         }}
//       >
//         <Toast
//           open={this.state.toast.open}
//           message={this.state.toast.message}
//           severity={this.state.toast.severity}
//           handleClose={this.handleCloseToast}
//         />

//         <div
//           id="payment-container"
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: "rgba(0,0,0,0.7)",
//             display: "none",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 1000,
//           }}
//         ></div>

//         <Container
//           maxWidth="sm"
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             width: "100%",
//             maxWidth: { xs: "100%" },
//             overflow: "visible",
//             textAlign: "center",
//           }}
//         >

//           <Box
//   sx={{
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     minHeight: "50vh",  // This makes sure the container takes at least the full viewport height
//     p: 2,               // Add some padding to prevent touching screen edges
//   }}
// >
//           <Card
//             elevation={8}
//             sx={{
//               backgroundColor: "transparent",
//               backgroundImage: "none",
//               border: "1px solid #FFC857",
              
//               borderRadius: "5px",
//               width: "100%",
//               maxWidth: { xs: "100%", sm: "450px" },
//               overflow: "visible",
//             }}
//           >
//             <CardContent sx={{ p: { xs: 3, sm: 4 }, textAlign: "center" }}>
//               <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
//                 <img src="/logo2.png" alt="logo" className="logo" width="150" />
//               </Box>

//               {this.RenderBox()}

//               {this.state.active == "verify" && (
//                 <Box sx={{ mt: 3, textAlign: "center" }}>
//                   <Typography variant="body2" sx={{ color: "white", mb: 1 }}>
//                     {this.state.active == "login"
//                       ? "Don't have an account"
//                       : this.state.active == "signup"
//                         ? "Already have an account"
//                         : "Login With another Account"}
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     onClick={() => {
//                       this.setState({
//                         active:
//                           this.state.active == "login" ? "signup" : this.state.active == "signup" ? "login" : "login",
//                       })
//                     }}
//                     sx={{
//                       color: Colors.primary,
//                       cursor: "pointer",
//                       fontWeight: "medium",
//                       "&:hover": {
//                         textDecoration: "underline",
//                       },
//                     }}
//                   >
//                     {this.state.active == "login"
//                       ? "Register"
//                       : this.state.active == "signup"
//                         ? "Login"
//                         : "Back to Login"}
//                   </Typography>
//                 </Box>
//               )}
//             </CardContent>
//           </Card>
//           </Box>
//         </Container>

//         <IsolatedStatusModal
//           isOpen={this.state.modalOpen}
//           onClose={this.closeModal}
//           type={this.state.modalType}
//           title={this.state.modalTitle}
//           message={this.state.modalMessage}
//           buttonText="OK"
//         />
//       </div>
//     )
//   }
// }

// export default redux(LoginScreen)
"use client"

import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import "./styles.css"
import Colors from "../../common/Colors"
import routes from "../../routes/URL"
import { base_url } from "../../services/API"
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Radio,
  FormControlLabel,
  InputAdornment,
  Card,
  CardContent,
} from "@mui/material"
import { Email, Phone, Person, Refresh, ArrowForward } from "@mui/icons-material"
import IsolatedStatusModal from "../../components/StatusModal"
import Toast from "../../components/Toast"
import axios from "axios"

const errors = {
  uname: "invalid username",
  pass: "invalid mobile",
}

class LoginScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      isLoaded: false,
      active: "login",
      otp: "",
      email: "",
      mobile: "",
      name: "",
      user_id: null,
      user_type: "outlet",
      sendingOTP: false,
      modalOpen: false,
      modalType: "success",
      modalTitle: "",
      modalMessage: "",
      userData: null,
      subscriptionPlans: [], // Add this to store plans from API
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  componentDidMount() {
    const token = localStorage.getItem("token")
    if (token && this.props.isAuth) {
      this.props.history.push(routes.admin.dashboard)
    }

    // Load Cashfree SDK
    const script = document.createElement("script")
    script.src = "https://sdk.cashfree.com/js/ui/2.0.0/cashfree.sandbox.js"
    script.async = true
    document.body.appendChild(script)

    // Load subscription plans
    this.loadSubscriptionPlans()
  }

  // Add method to load subscription plans
  loadSubscriptionPlans = async () => {
    try {
      const response = await API(this, "get", URL_PATH.subscriptionPlans)
      const { status, data } = response

      if (status === "success") {
        this.setState({ subscriptionPlans: data })
      }
    } catch (error) {
      console.error("Failed to load subscription plans:", error)
    }
  }

  showModal = (type, title, message) => {
    this.setState({
      modalOpen: true,
      modalType: type,
      modalTitle: title,
      modalMessage: message,
    })
  }

  closeModal = () => {
    this.setState({ modalOpen: false })
  }

  sendOTP = async (event) => {
    event.preventDefault()

    const fd = {
      user_type: "outlet",
    }

    const emailPhone = event.target.email.value

    if (emailPhone.includes("@")) {
      fd.check_for = "email"
      fd.email = emailPhone
    } else {
      fd.check_for = "mobile"
      fd.mobile = emailPhone
    }

    const { status, message, data } = await API(this, "post", URL_PATH.login, fd)

    if (status == "error") {
      return this.showModal("error", "Error", message)
    } else if (status == "redirect") {
      window.location.href = data
      return
    } else if (status == "success") {
      const { otp_length, name, email, mobile, token, message, signup = false, emailDisabled, mobileDisabled } = data

      this.setState({
        name,
        otp_length,
        token,
        otpMessage: message,
        signup,
        active: "verify",
        email,
        mobile,
        emailDisabled,
        mobileDisabled,
      })
      return
    }

    return this.showToast("Something went wrong", "error")
  }

handleSubmit = async (event) => {
  event.preventDefault();
  const formData = new FormData(event.target);

  try {
    console.log("Sending OTP verification request...");
    const result = await API(this, "post", URL_PATH.verify_otp, formData);
    console.log("Full API Response:", result);

    if (result.status === "error" || result.success === false || result.length === 0) {
      const errorMsg = result.message || "Mobile No is already registered";
      console.log("OTP verification failed:", errorMsg);
      return this.showToast(errorMsg, "error");
    }

    console.log("OTP verification successful:", result);

    if (result.status === "success" || result.success === true) {
      console.log("Processing successful OTP verification...");
      
      // Extract user data from response
      const { data } = result;
      const userId = data?.user?.id || data?.user_id;
      const userData = data?.user || {};
      
      // Store token in localStorage for authenticated requests
      if (data?.token) {
        // localStorage.setItem("token", data.token);
        localStorage.setItem("outlatetoken", data.token);
      }
      
      console.log("User ID from verification:", userId);
      
      this.setState({
        otp_length: data?.otp_length,
        token: data?.token,
        otpMessage: data?.message,
        active: "payment",
        user_id: userId,
        userData: userData,
      }, () => {
        console.log("State after update:", this.state);
        console.log("User ID set to:", userId);
      });

      this.showToast(data?.message || "OTP verified successfully!", "success");
      return;
    }
  } catch (error) {
    console.error("API Call Failed:", error);
    this.showToast("Failed to verify OTP. Please try again.", "error");
  }
};

  CreateOutletBox() {
    return (
      <form onSubmit={(e) => this.handleCreateOutlet(e)} id="outlet-form">
        <Typography variant="h5" sx={{ color: "white", mb: 3, textAlign: "center" }}>
          Create New Outlet
        </Typography>

        <TextField
          fullWidth
          name="outlet_name"
          label="Outlet Name"
          variant="outlined"
          margin="normal"
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />

        <TextField
          fullWidth
          name="gst_number"
          label="GST Number"
          variant="outlined"
          margin="normal"
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />

        <TextField
          fullWidth
          name="fssai_number"
          label="FSSAI Number"
          variant="outlined"
          margin="normal"
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />

        <TextField
          fullWidth
          name="phone"
          label="Phone"
          variant="outlined"
          margin="normal"
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Phone sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />

        <TextField
          fullWidth
          name="address"
          label="Address"
          variant="outlined"
          margin="normal"
          multiline
          rows={2}
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />

        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <TextField
            fullWidth
            name="city"
            label="City"
            variant="outlined"
            margin="normal"
            required
            InputLabelProps={{
              style: { color: "white" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "rgba(255, 255, 255, 0.3)",
                },
                "&:hover fieldset": {
                  borderColor: "white",
                },
                "&.Mui-focused fieldset": {
                  borderColor: Colors.primary,
                },
                color: "white",
              },
            }}
          />

          <TextField
            fullWidth
            name="state"
            label="State"
            variant="outlined"
            margin="normal"
            required
            InputLabelProps={{
              style: { color: "white" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "rgba(255, 255, 255, 0.3)",
                },
                "&:hover fieldset": {
                  borderColor: "white",
                },
                "&.Mui-focused fieldset": {
                  borderColor: Colors.primary,
                },
                color: "white",
              },
            }}
          />
        </Box>

        <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
          <TextField
            fullWidth
            name="pin_code"
            label="PIN Code"
            variant="outlined"
            margin="normal"
            required
            InputLabelProps={{
              style: { color: "white" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "rgba(255, 255, 255, 0.3)",
                },
                "&:hover fieldset": {
                  borderColor: "white",
                },
                "&.Mui-focused fieldset": {
                  borderColor: Colors.primary,
                },
                color: "white",
              },
            }}
          />

          <TextField
            fullWidth
            name="country"
            label="Country"
            variant="outlined"
            margin="normal"
            defaultValue="India"
            required
            InputLabelProps={{
              style: { color: "white" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "rgba(255, 255, 255, 0.3)",
                },
                "&:hover fieldset": {
                  borderColor: "white",
                },
                "&.Mui-focused fieldset": {
                  borderColor: Colors.primary,
                },
                color: "white",
              },
            }}
          />
        </Box>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          endIcon={<ArrowForward />}
          sx={{
            mt: 1,
            mb: 2,
            backgroundColor: Colors.primary,
            color: "black",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: Colors.primary,
              opacity: 0.9,
            },
          }}
        >
          Create Outlet
        </Button>
      </form>
    )
  }

handleCreateOutlet = async (event) => {
  event.preventDefault();

  try {
    const formData = new FormData(event.target);
    
    // Get user ID from state (set during OTP verification)
    const userId = this.state.user_id || this.props.auth?.user?.id;
    
    if (!userId) {
      return this.showToast("User authentication required", "error");
    }
  
    // Create complete outlet data with all required fields
    const outletData = {
      parent_hotel_id: this.props.selectedHotelId?.id,
      outlet_name: formData.get("outlet_name"),
      gst_number: formData.get("gst_number"),
      fssai_number: formData.get("fssai_number"),
      phone: formData.get("phone"),
      address: formData.get("address"),
      city: formData.get("city"),
      state: formData.get("state"),
      pin_code: formData.get("pin_code"),
      country: formData.get("country"),
      user_id: userId, // Include user ID in the payload
    };

    console.log("Creating outlet with data:", outletData);

    const result = await API(this, "post", `${base_url}/hotel/createOutlet`, outletData);

    if (result.status === "success") {
      this.showToast("Outlet created successfully!", "success");
      this.props.history.push(routes.admin.dashboard.root);
    } else {
      this.showToast(result.message || "Failed to create outlet", "error");
    }
  } catch (error) {
    console.error("Error creating outlet:", error);
    this.showToast("An error occurred. Please try again.", "error");
  }
};

  // Updated PaymentBox method with subscription screen styling and logic
 // Updated PaymentBox method with fixes
PaymentBox() {
  const { subscriptionPlans } = this.state
const predefinedFeatures = {
    "mini": [
      "Cloud-Based POS",
      "Order Tracking",
      "Pick-Up Orders",
      "Order History",
      "Manage Tips",
      "Discounts & Coupons",
      "Variations & Add-Ons",
       "Time-Slot Wise Menu",
       "Space-Wise Menu Pricing",
       "Digital QR-Based Menu",
       "Thermal Print Support",
        "Cart Sharing",
        "Digital Token for Queue Mgt.",
        "User Feedback Collection",
        "Google Reviews Integration",
        "Multi-Language Support",
        "SMS & Notification Alerts",
        "Real-Time Order Status",
        "Table & Space Management",
        "Table & Hall Bookings",
        "Change / Merge / Split Table",
        "Third-Party Integrations ",
        "Payment Gateway Integrations",
        "Real-Time Dashboard & Reports",
        "Customer List (CRM)",
        "iOS, Android & Web Applications",
        "Daily Cloud Backup",
        "Special Menu Banner",
        "24/7 Customer Support",





      ],
    "pro": [
      "Cloud-Based POS",
      "Order Tracking",
      "Pick-Up Orders",
      "Order History",
      "Manage Tips",
      "Discounts & Coupons",
      "Variations & Add-Ons",
       "Time-Slot Wise Menu",
       "Space-Wise Menu Pricing",
       "Digital QR-Based Menu",
       "Thermal Print Support",
        "Cart Sharing",
        "Digital Token for Queue Mgt.",
        "User Feedback Collection",
        "Google Reviews Integration",
        "Multi-Language Support",
        "SMS & Notification Alerts",
        "Real-Time Order Status",
        "Table & Space Management",
        "Table & Hall Bookings",
        "Change / Merge / Split Table",
        "Third-Party Integrations ",
        "Payment Gateway Integrations",
        "Real-Time Dashboard & Reports",
        "Customer List (CRM)",
        "iOS, Android & Web Applications",
        "Daily Cloud Backup",
        "Special Menu Banner",
        "24/7 Customer Support",
        "Call the Waiter Feature",
        "KOT & KDS with Print",
        "Employee Management",
        "Inventory Management",
        "Staff Login with few Permissions"

    ]
  };

  // Filter to show only Mini and Pro plans
  const filteredPlans = subscriptionPlans
    .filter(
      (plan) =>
        plan.name.toLowerCase().includes("mini") ||
        plan.name.toLowerCase().includes("pro") ||
        plan.tier === 1 ||
        plan.tier === 2,
    )
    .filter((plan) => plan.price > 0) // Only paid plans

  // If no plans from API, use fallback
  const plansToShow = filteredPlans.length > 0 ? filteredPlans : [
    {
      id: 1,
      name: "Eatable Pro",
      description: "Perfect for growing businesses",
      price: 999,
      monthly_price: 999,
      tier: 1,
      features: predefinedFeatures.pro.map(name => ({ name }))
    },
    {
      id: 2,
      name: "Eatable Mini",
      description: "Great for small businesses",
      price: 499,
      monthly_price: 499,
      tier: 2,
      features: predefinedFeatures.mini.map(name => ({ name }))
    }
  ];
  const enhancedPlans = plansToShow.map(plan => {
    // Determine plan type (mini or pro)
    const isMini = plan.name.toLowerCase().includes("mini") || plan.tier === 2;
    const planType = isMini ? "mini" : "pro";
    
    // Keep all plan data from backend but use predefined feature names
    return {
      ...plan,
      features: predefinedFeatures[planType].map(name => ({ name }))
    };
  });

  return (
    <div
      style={{
        backgroundColor: "#02111B",
        minHeight: "100vh",
        fontFamily: "'Poppins', sans-serif",
        color: "#333",
        padding: "20px 0",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 20px",
          
        }}
      >
        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "40px",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: "32px",
              fontWeight: "700",
              color: Colors.primary,
              margin: "0 0 15px 0",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            Choose Your Plan
          </Typography>
          <div
            style={{
              width: "60px",
              height: "3px",
              background: `linear-gradient(90deg, ${Colors.primary}, #ff9a44)`,
              margin: "0 auto 15px",
              borderRadius: "2px",
            }}
          ></div>
          <Typography
            variant="body1"
            sx={{
              fontSize: "16px",
              color: "white",
              maxWidth: "500px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            Select the perfect plan for your outlet needs
          </Typography>
        </div>

        {/* Plans Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: plansToShow.length === 1 ? "1fr" : "repeat(auto-fit, minmax(350px, 1fr))",
            gap: "30px",
            marginBottom: "40px",
            justifyContent: "center",
          }}
        >
          {enhancedPlans.map((item, index) => {
            const isPopular = item.tier === 1

            return (
              <div
                key={index}
                style={{
                  position: "relative",
                  transition: "all 0.3s ease",
                  borderRadius: "12px",
                  backgroundColor: "#041A29",
                  display: "flex",
                  flexDirection: "column",
                  maxWidth: "450px",
                  margin: "0 auto",
                  ...(isPopular
                    ? {
                        transform: "translateY(-10px)",
                        boxShadow: "0 15px 30px rgba(0,0,0,0.15)",
                        // border: `2px solid ${Colors.primary}`,
                      }
                    : {
                        boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                      }),
                }}
              >
              

                

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    padding: "30px",
                  }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #eee",
                      paddingBottom: "25px",
                      marginBottom: "25px",
                    }}
                  >
                    <h3
                      style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        margin: "0 0 10px 0",
                        color: "white",
                        ...(isPopular ? { color: Colors.primary } : {}),
                      }}
                    >
                      {item.name}
                    </h3>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "white",
                        margin: "0 0 20px 0",
                        lineHeight: "1.5",
                      }}
                    >
                      {item.description}
                    </p>

                    <div style={{ margin: "25px 0" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <div style={{ textAlign: "center" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "24px",
                                fontWeight: "bold",
                                color: "white",
                                marginRight: "5px",
                                lineHeight: "1",
                                ...(isPopular ? { color: Colors.primary } : {}),
                              }}
                            >
                              ₹
                            </span>
                            <span
                              style={{
                                fontSize: "48px",
                                fontWeight: "800",
                                lineHeight: "1",
                                color: "white",
                                ...(isPopular ? { color: Colors.primary } : {}),
                              }}
                            >
                              {(item.monthly_price || item.price).toLocaleString("en-IN")}
                            </span>
                            {item.price > 0 && (
                              <p
                                style={{
                                  fontSize: "20px",
                                  color: "#aaa",
                                  marginTop: "15px",
                                  marginLeft: "10px",
                                  textDecoration: "line-through",
                                }}
                              >
                                ₹{((item.monthly_price || item.price) * 2).toLocaleString("en-IN")}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <p
                        style={{
                          fontSize: "14px",
                          color: "white",
                          margin: "5px 0 0 0",
                        }}
                      >
                        Monthly
                      </p>
                      <p style={{ color: "white", fontSize: "16px" }}>BILLED YEARLY</p>
                    </div>
                  </div>

                  <div
                    style={{
                      flexGrow: "1",
                      marginBottom: "25px",
                    }}
                  >
                    <ul
                      style={{
                        listStyle: "none",
                        padding: "0",
                        margin: "0",
                      }}
                    >
                      {item.features && item.features.length > 0 ? (
                        item.features.map((feature, featureIndex) => (
                          <li
                            key={featureIndex}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "15px",
                              color: "#555",
                              fontSize: "15px",
                              lineHeight: "1.4",
                            }}
                          >
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "22px",
                                height: "22px",
                                borderRadius: "50%",
                                background: isPopular ? Colors.primary : "#4CAF50",
                                marginRight: "12px",
                                fontSize: "12px",
                                color: isPopular ? "black" : "white",
                                flexShrink: "0",
                              }}
                            >
                              ✓
                            </span>
                            <span style={{ color: "white" }}>{feature.name}</span>
                          </li>
                        ))
                      ) : (
                        <li
                          style={{
                            color: "#999",
                            fontStyle: "italic",
                            fontSize: "14px",
                          }}
                        >
                          All features included
                        </li>
                      )}
                    </ul>
                  </div>

                  {/* Individual Select Plan Button */}
                  <div style={{ textAlign: "center", marginTop: "auto" }}>
                    <Button
                      variant="contained"
                      size="large"
                      endIcon={<ArrowForward />}
                      onClick={() => this.handleIndividualPlanSelection(item.id)}
                      sx={{
                        width: "100%",
                        padding: "12px 30px",
                        backgroundColor: item.tier === 1 ? Colors.primary : "#00A651",
                        color: item.tier === 1 ? "black" : "white",
                        fontWeight: "bold",
                        fontSize: "16px",
                        borderRadius: "30px",
                        boxShadow:
                          item.tier === 1
                            ? "0 4px 15px rgba(250, 172, 64, 0.3)"
                            : "0 4px 15px rgba(76, 175, 80, 0.3)",
                        "&:hover": {
                          backgroundColor: item.tier === 1 ? Colors.primary : "#00A651",
                          opacity: 0.9,
                          transform: "translateY(-2px)",
                          boxShadow:
                            item.tier === 1
                              ? "0 6px 20px rgba(250, 172, 64, 0.4)"
                              : "0 6px 20px rgba(76, 175, 80, 0.4)",
                        },
                        transition: "all 0.3s ease",
                      }}
                    >
                      Select Plan
                      {item.tier === 1 && (
                        <span style={{ marginLeft: "8px" }}>→</span>
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

handleIndividualPlanSelection = async (planId) => {
  if (!planId) {
    return this.showToast("Invalid plan selection", "error");
  }

  try {
    // For free plan, go directly to create outlet
    if (planId === "4") {
      this.setState({ active: "create_outlet" });
      return;
    }

    // Get user ID from state
    const userId = this.state.user_id;
    
    if (!userId) {
      return this.showToast("User authentication required", "error");
    }

    // For paid plans, initialize payment
    const paymentData = {
      plan_id: planId,
      type: "subscribe",
      payment_gateway: "cashfree",
      outlate_user_id: userId, // Use the stored user ID
    };

    console.log("Payment data with user ID:", paymentData);

    const token = localStorage.getItem("outlatetoken") || localStorage.getItem("token");

    try {
      const response = await axios.post(`${base_url}/subscription/subscribe`, paymentData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("Payment API response:", response.data);

      if (response.data.status !== "success") {
        return this.showToast(response.data.message || "Payment initiation failed", "error");
      }

      this.processCashfreePayment(response.data);
    } catch (error) {
      console.error("API error:", error);
      this.showToast("There was an error initiating your payment. Please try again.", "error");
    }
  } catch (error) {
    console.error("Payment error:", error);
    this.showToast("There was an error initiating your payment", "error");
  }
};

  handlePaymentSelection = async (event) => {
    event.preventDefault()
    const formData = new FormData(event.target)
    const planId = formData.get("plan_id")

    if (!planId) {
      return this.showToast("Please select a plan to continue", "error")
    }

    try {
      // For free plan, go directly to create outlet
      if (planId === "4") {
        this.setState({ active: "create_outlet" })
        return
      }

      // For paid plans, initialize payment
      const paymentData = {
        plan_id: planId,
        type: "subscribe",
        payment_gateway: "cashfree",
        outlate_user_id: this.state.user_id,
      }

      const token = localStorage.getItem("outlatetoken") || localStorage.getItem("token")

      try {
        const base_url = "https://etableapp.in/api/hotelowner"
        const response = await axios.post(`${base_url}/subscription/subscribe`, paymentData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        console.log("Payment API response:", response.data)

        if (response.data.status !== "success") {
          return this.showToast(response.data.message || "Payment initiation failed", "error")
        }

        this.processCashfreePayment(response.data)
      } catch (error) {
        console.error("API error:", error)
        this.showToast("There was an error initiating your payment. Please try again.", "error")
      }
    } catch (error) {
      console.error("Payment error:", error)
      this.showToast("There was an error initiating your payment", "error")
    }
  }

  processCashfreePayment = (response) => {
    try {
      const { payment_session_id } = response.data

      if (!payment_session_id) {
        return this.showToast("Invalid Cashfree payment session data", "error")
      }

      if (window.Cashfree) {
        const paymentContainer = document.getElementById("payment-container")
        if (paymentContainer) {
          paymentContainer.style.display = "flex"
          paymentContainer.innerHTML = ""

          const innerContainer = document.createElement("div")
          innerContainer.style.position = "relative"
          innerContainer.style.width = "450px"
          innerContainer.style.maxWidth = "90%"
          innerContainer.style.backgroundColor = "white"
          innerContainer.style.borderRadius = "8px"
          innerContainer.style.padding = "20px"
          innerContainer.style.boxShadow = "0 5px 15px rgba(0,0,0,0.3)"

          const closeButton = document.createElement("button")
          closeButton.innerHTML = "×"
          closeButton.style.position = "absolute"
          closeButton.style.top = "10px"
          closeButton.style.right = "10px"
          closeButton.style.background = "none"
          closeButton.style.border = "none"
          closeButton.style.color = "#333"
          closeButton.style.fontSize = "24px"
          closeButton.style.cursor = "pointer"
          closeButton.onclick = () => {
            paymentContainer.style.display = "none"
            paymentContainer.innerHTML = ""
          }
          innerContainer.appendChild(closeButton)

          const formContainer = document.createElement("div")
          formContainer.id = "cashfree-form"
          formContainer.style.marginTop = "20px"
          innerContainer.appendChild(formContainer)

          paymentContainer.appendChild(innerContainer)
        }

        const cashfree = new window.Cashfree(payment_session_id)

        const dropinConfig = {
          components: ["order-details", "card", "netbanking", "app", "upi"],
          onSuccess: (data) => {
            console.log("Cashfree success:", data)
            const paymentContainer = document.getElementById("payment-container")
            if (paymentContainer) {
              paymentContainer.style.display = "none"
            }

            if (data.order && data.order.status === "PAID") {
              this.paid(data)
              this.setState({ active: "create_outlet" })
            } else {
              this.showToast("Payment is not confirmed yet. Please wait for confirmation.", "warning")
            }
          },
          onFailure: (data) => {
            console.log("Cashfree failure:", data)
            const paymentContainer = document.getElementById("payment-container")
            if (paymentContainer) {
              paymentContainer.style.display = "none"
            }
            this.showToast("Payment failed. Please try again.", "error")
          },
          style: {
            backgroundColor: "#f9f9f9",
            color: "#11385b",
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
            errorColor: "#ff0000",
            theme: "light",
          },
        }

        cashfree.drop(document.getElementById("cashfree-form"), dropinConfig)
      } else {
        console.error("Cashfree SDK not loaded")
        this.showToast("Failed to initialize payment", "error")
      }
    } catch (error) {
      console.error("Cashfree payment error:", error)
      this.showToast("Failed to initialize payment", "error")
    }
  }

  paid = async (data) => {
    try {
      const fd = {
        custom: true,
        orderId: data.order?.orderId,
        status: data.order?.status,
        gateway: "cashfree",
      }

      const response = await API(this, "post", URL_PATH.paymentDone, fd)
      const { status, message } = response

      if (status === "success") {
        this.showToast("Payment processed successfully", "success")
        this.setState({ active: "create_outlet" })
      } else {
        this.showToast(message || "Payment verification failed", "error")
      }
    } catch (error) {
      console.error("Payment processing error:", error)
      this.showToast("There was an error processing your payment", "error")
    }
  }

  RenderBox() {
    console.log("Current active state in RenderBox:", this.state.active)
    if (this.state.active == "login") return this.LoginBox()
    if (this.state.active == "signup") return this.SignUpBox()
    if (this.state.active == "verify") return this.VerifyBox()
    if (this.state.active == "create_outlet") {
      console.log("Rendering CreateOutletBox")
      return this.CreateOutletBox()
    }
    // Payment case is now handled in render() method directly
    return null
  }

  renderErrorMessage = (name) => {
    return <div className="error-message">{errors[name]}</div>
  }

  LoginBox() {
    return (
      <form onSubmit={(e) => this.sendOTP(e)} id="login-form">
        <TextField
          fullWidth
          name="email"
          label="Email/Mobile"
          variant="outlined"
          margin="normal"
          value={this.state.email}
          onChange={(e) => this.setState({ email: e.target.value })}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 3,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          endIcon={<ArrowForward />}
          sx={{
            mt: 1,
            mb: 2,
            backgroundColor: Colors.primary,
            color: "black",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: Colors.primary,
              opacity: 0.9,
            },
          }}
        >
          Continue
        </Button>
      </form>
    )
  }

  SignUpBox() {
    return (
      <form onSubmit={(e) => this.handleSubmit(e)} id="login-form">
        <TextField
          fullWidth
          name="name"
          label="Name"
          variant="outlined"
          margin="normal"
          value={this.state.name}
          onChange={(e) => this.setState({ name: e.target.value })}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />

        <TextField
          fullWidth
          name="email"
          label="Email (username)"
          variant="outlined"
          margin="normal"
          value={this.state.email}
          onChange={(e) => this.setState({ email: e.target.value })}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Email sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />

        <TextField
          fullWidth
          name="mobile"
          label="Mobile Number"
          variant="outlined"
          margin="normal"
          value={this.state.mobile}
          onChange={(e) => this.setState({ mobile: e.target.value })}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Phone sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 3,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />

        <input type="hidden" name="user_type" value="hotel" />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          endIcon={<ArrowForward />}
          sx={{
            mt: 1,
            mb: 2,
            backgroundColor: Colors.primary,
            color: "black",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: Colors.primary,
              opacity: 0.9,
            },
          }}
        >
          Submit
        </Button>
      </form>
    )
  }

  VerifyBox() {
    const {
      otp_length,
      token,
      otp,
      otpMessage,
      signup = false,
      emailDisabled = false,
      mobileDisabled = false,
      sendingOTP,
    } = this.state

    return (
      <form onSubmit={(e) => this.handleSubmit(e)} id="login-form">
        <input type="hidden" name="key" value={token} />

        <Box sx={{ mb: 3, mt: 2 }}>
          <Typography variant="body1" sx={{ color: "white", mb: 2, mt: 2 }}>
            {otpMessage}
          </Typography>

          <TextField
            fullWidth
            name="otp"
            label="Verification Code"
            variant="outlined"
            type="number"
            inputProps={{
              maxLength: otp_length,
              minLength: otp_length,
            }}
            value={otp}
            onChange={(e) => this.setState({ otp: e.target.value })}
            InputLabelProps={{
              style: { color: "white" },
            }}
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "rgba(255, 255, 255, 0.3)",
                },
                "&:hover fieldset": {
                  borderColor: "white",
                },
                "&.Mui-focused fieldset": {
                  borderColor: Colors.primary,
                },
                color: "white",
              },
            }}
          />

          <Button
            variant="text"
            startIcon={<Refresh />}
            disabled={sendingOTP}
            onClick={async () => {
              this.setState({ sendingOTP: true, otp: "" })
              const result = await API(this, "post", URL_PATH.resendOtp, { key: token })
              const { status, data, message } = result
              if (status == "success") {
                this.setState({
                  token: data.token,
                  sendingOTP: false,
                })
              } else {
                this.showToast(message, "error")
                this.setState({ sendingOTP: false })
              }
            }}
            sx={{
              color: Colors.primary,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.05)",
              },
            }}
          >
            Resend OTP
          </Button>
        </Box>

        {signup == false && (
          <>
            <TextField
              fullWidth
              name="name"
              label="Name"
              variant="outlined"
              margin="normal"
              value={this.state.name}
              onChange={(e) => this.setState({ name: e.target.value })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person sx={{ color: "white" }} />
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                style: { color: "white" },
              }}
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "rgba(255, 255, 255, 0.3)",
                  },
                  "&:hover fieldset": {
                    borderColor: "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: Colors.primary,
                  },
                  color: "white",
                },
              }}
            />

            <TextField
              fullWidth
              name="email"
              label="Email"
              variant="outlined"
              margin="normal"
              value={this.state.email}
              onChange={(e) => this.setState({ email: e.target.value })}
              disabled={emailDisabled}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email sx={{ color: emailDisabled ? "gray" : "white" }} />
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                style: { color: emailDisabled ? "gray" : "white" },
              }}
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "rgba(255, 255, 255, 0.3)",
                  },
                  "&:hover fieldset": {
                    borderColor: emailDisabled ? "gray" : "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: emailDisabled ? "gray" : Colors.primary,
                  },
                  color: emailDisabled ? "gray" : "white",
                },
              }}
            />

            <TextField
              fullWidth
              name="mobile"
              label="Mobile Number"
              variant="outlined"
              margin="normal"
              value={this.state.mobile}
              onChange={(e) => this.setState({ mobile: e.target.value })}
              disabled={mobileDisabled}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone sx={{ color: mobileDisabled ? "gray" : "white" }} />
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                style: { color: mobileDisabled ? "gray" : "white" },
              }}
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "rgba(255, 255, 255, 0.3)",
                  },
                  "&:hover fieldset": {
                    borderColor: mobileDisabled ? "gray" : "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: mobileDisabled ? "gray" : Colors.primary,
                  },
                  color: mobileDisabled ? "gray" : "white",
                },
              }}
            />

            <input type="hidden" name="user_type" value="hotel" />
          </>
        )}

        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          endIcon={<ArrowForward />}
          sx={{
            mt: 1,
            mb: 2,
            backgroundColor: Colors.primary,
            color: "black",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: Colors.primary,
              opacity: 0.9,
            },
          }}
        >
          Continue
        </Button>
      </form>
    )
  }

  render() {
    // If payment state, render full-width payment section
    if (this.state.active === "payment") {
      return (
        <div>
          <Toast
            open={this.state.toast.open}
            message={this.state.toast.message}
            severity={this.state.toast.severity}
            handleClose={this.handleCloseToast}
          />

          <div
            id="payment-container"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.7)",
              display: "none",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
            }}
          ></div>
          {this.PaymentBox()}


          <IsolatedStatusModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            type={this.state.modalType}
            title={this.state.modalTitle}
            message={this.state.modalMessage}
            buttonText="OK"
          />
        </div>
      )
    }

    // For all other states, use the constrained container layout
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />

        <div
          id="payment-container"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "none",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        ></div>

        <Container
          maxWidth="sm"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            maxWidth: { xs: "100%", sm: "450px" },
            overflow: "visible",
            textAlign: "center",
          }}
        >
          <Card
            elevation={8}
            sx={{
              backgroundColor: "transparent",
              backgroundImage: "none",
              border: "1px solid #FFC857",
              borderRadius: "5px",
              width: "100%",
              maxWidth: { xs: "100%", sm: "450px" },
              overflow: "visible",
            }}
          >
            <CardContent sx={{ p: { xs: 3, sm: 4 }, textAlign: "center" }}>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
                <img src="/logo2.png" alt="logo" className="logo" width="150" />
              </Box>

              {this.RenderBox()}

              {this.state.active == "verify" && (
                <Box sx={{ mt: 3, textAlign: "center" }}>
                  <Typography variant="body2" sx={{ color: "white", mb: 1 }}>
                    {this.state.active == "login"
                      ? "Don't have an account"
                      : this.state.active == "signup"
                        ? "Already have an account"
                        : "Login With another Account"}
                  </Typography>
                  <Typography
                    variant="body2"
                    onClick={() => {
                      this.setState({
                        active:
                          this.state.active == "login" ? "signup" : this.state.active == "signup" ? "login" : "login",
                      })
                    }}
                    sx={{
                      color: Colors.primary,
                      cursor: "pointer",
                      fontWeight: "medium",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {this.state.active == "login"
                      ? "Register"
                      : this.state.active == "signup"
                        ? "Login"
                        : "Back to Login"}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Container>

        <IsolatedStatusModal
          isOpen={this.state.modalOpen}
          onClose={this.closeModal}
          type={this.state.modalType}
          title={this.state.modalTitle}
          message={this.state.modalMessage}
          buttonText="OK"
        />
      </div>
    )
  }
}

export default redux(LoginScreen)